<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="md:mt-32 mt-24 mx-auto">
      <div
        class="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 space-y-8 text-gray-700 leading-relaxed"
      >
        <h2 class="text-3xl font-extrabold mb-8 text-gray-900">
          Shipping Policy
        </h2>
        <p class="text-lg">
          We aim to deliver your orders safely and on time using reliable
          shipping partners.
        </p>

        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Delivery Time
          </h3>
          <p>
            Orders are typically delivered within 3–7 business days depending on
            your location.
          </p>
        </div>

        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Shipping Charges
          </h3>
          <p>
            Shipping fees are calculated at checkout based on order size and
            delivery destination.
          </p>
        </div>

        <p class="text-sm text-gray-500 pt-4 border-t">
          Last updated: January 2026
        </p>
      </div>
    </div>
  </div>
</div>
